import dateFormat from 'dateformat';
import { useHistory } from 'react-router-dom';
import { HistoryDropdown } from '../../../../shared';

type ResultHistoryDropdownProps = {
  testResults: Array<{ id: number; createdAt: string }>;
  currentResultId: number;
  redirectPath: string;
  idUser?: string;
};

const ResultHistoryDropdown = ({
  testResults,
  currentResultId,
  redirectPath,
  idUser,
}: ResultHistoryDropdownProps) => {
  const history = useHistory();

  const sortedResults = [...testResults].sort(
    (a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf(),
  );

  const handleSelect = (id: string | number) => {
    if (id === currentResultId) {
      return;
    }

    history.push(!idUser ? `${redirectPath}/${id}` : `${redirectPath}/${id}/${idUser}`);
  };

  return (
    <HistoryDropdown
      items={sortedResults.map(test => ({
        id: test.id,
        label: test.createdAt
          ? dateFormat(new Date(test.createdAt), 'dd/mm/yyyy, HH:MM')
          : '-',
      }))}
      activeId={currentResultId}
      onSelect={handleSelect}
    />
  );
};

export default ResultHistoryDropdown;
